"use strict";

var _classCallCheck = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Bucket_1 = require("../entity/Bucket");

var StubBucket = /*#__PURE__*/function (_Bucket_1$default) {
  _inherits(StubBucket, _Bucket_1$default);

  var _super = _createSuper(StubBucket);

  function StubBucket() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '123' : _ref$id;

    _classCallCheck(this, StubBucket);

    return _super.call(this, {
      id: id
    });
  }

  return StubBucket;
}(Bucket_1.default);

exports.default = StubBucket;